import { useMemo, useState } from "react";

export const activityPresetViews = [
  ["all", "All activity", "all"],
  ["investors", "Investor Relations", "investor"],
  ["email", "Email Follow-up", "email"],
  ["documents", "Document Activity", "document"],
  ["access", "Access Decisions", "access"],
];

function eventMatchesFilter(item, filter) {
  if (filter === "all") return true;
  if (filter === "investor") return item.activity_type.includes("investor") || item.activity_type === "lead_received";
  return item.activity_type.includes(filter);
}

function isInDateRange(item, range) {
  if (range === "all") return true;
  return new Date(item.created_at).getTime() >= Date.now() - Number(range) * 24 * 60 * 60 * 1000;
}

function filterActivityItems(items, filter, dateRange, query) {
  const normalizedQuery = query.toLowerCase();
  return items.filter((item) => eventMatchesFilter(item, filter) && isInDateRange(item, dateRange) && `${item.title} ${item.description}`.toLowerCase().includes(normalizedQuery));
}

export default function useActivityFilters(items) {
  const [filter, setFilter] = useState("all");
  const [query, setQuery] = useState("");
  const [dateRange, setDateRange] = useState("all");
  const [activePreset, setActivePreset] = useState("all");
  const filteredItems = useMemo(() => filterActivityItems(items, filter, dateRange, query), [items, filter, dateRange, query]);

  const applyPreset = (id, presetFilter) => {
    setActivePreset(id);
    setFilter(presetFilter);
    setQuery("");
    setDateRange("all");
  };

  const setCustomQuery = (value) => {
    setActivePreset("custom");
    setQuery(value);
  };

  const setCustomFilter = (value) => {
    setActivePreset("custom");
    setFilter(value);
  };

  const setCustomDateRange = (value) => {
    setActivePreset("custom");
    setDateRange(value);
  };

  return {
    activePreset,
    applyPreset,
    dateRange,
    filter,
    filteredItems,
    query,
    setCustomDateRange,
    setCustomFilter,
    setCustomQuery,
  };
}